import { AuthGuard } from "../guards/auth-guard";

export const withAuthGuard = (Component) => (props) =>
  (
    <AuthGuard>
      <Component {...props} />
    </AuthGuard>
  );
